import isNil from 'lodash/isNil';

const DANCING_SCRIPT_LOAD_SPEC = '400 36px "Dancing Script"';

export function isDancingScriptLoaded(): boolean {
  let result = true;

  if (!isNil(globalThis.document) && 'fonts' in globalThis.document) {
    try {
      result = globalThis.document.fonts.check(DANCING_SCRIPT_LOAD_SPEC);
    } catch {
      result = true;
    }
  }

  return result;
}

export async function preloadDancingScriptFont(): Promise<void> {
  let shouldLoad = false;

  if (!isNil(globalThis.document) && 'fonts' in globalThis.document) {
    shouldLoad = !isDancingScriptLoaded();
  }

  if (shouldLoad) {
    try {
      // Triggers the browser to fetch the @font-face resource early.
      await globalThis.document.fonts.load(DANCING_SCRIPT_LOAD_SPEC);
    } catch {
      // Best-effort preload; ignore errors so app boot isn't impacted.
    }
  }
}
